module.exports = __webpack_public_path__ + "img/mscc-logo-inverted.17de600a.svg";